import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./Components/Portfolio/Home/Home";
import Header from "./Components/Portfolio/Header/Header";
import Projects from "./Components/Portfolio/Projects/Projects";
import Nav from "./Components/Portfolio/Nav/Nav";
import Login from "./Components/Portfolio/Contact/Login";
import Contact from "./Components/Portfolio/Contact/contact";
import About from "./Components/Portfolio/About/about";
import HomeDashboard from "./Components/Dashboard/Home/HomeDashboard";
import Navbar from "./Components/Dashboard/NavBar/NavBar";
import ContactDashboard from "./Components/Dashboard/Contact/ContactDashboard";
import Logout from "./Components/Dashboard/Logout/logout";
import { RequireAuth } from "./Components/Portfolio/context/RequireAuth";
import ProjectsDashboard from "./Components/Dashboard/Projects/ProjectsDashboard";
import AddProject from "./Components/Dashboard/Projects/addProject";

export default class App extends React.Component {
  render() {
    // const state = useContext(DataContext);
    // const [isLogin, setIsLogin] = state.isLogin;
    return (
      <Router>
        <Routes>
          <Route
            exact
            path="/"
            element={
              <>
                <Header />
                <Home />
                <Nav />
              </>
            }
          />
          <Route
            exact
            path="/home"
            element={
              <>
                <Header />
                <Home />
                <Nav />
              </>
            }
          />
          <Route
            exact
            path="/projects"
            element={
              <>
                <Header />
                <Projects />
                <Nav />
              </>
            }
          />
          <Route
            exact
            path="/login"
            element={
              <>
                <Header />
                <Login />
              </>
            }
          />
          <Route
            exact
            path="/contact"
            element={
              <>
                <Header />
                <Contact />
                <Nav />
              </>
            }
          />
          <Route
            exact
            path="/about"
            element={
              <>
                <Header />
                <About />
                <Nav />
              </>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <>
                <Logout />
                <Navbar />
                <RequireAuth>
                  <HomeDashboard />
                </RequireAuth>
              </>
            }
          />
          <Route
            exact
            path="/editprojects"
            element={
              <>
                <RequireAuth>
                  <AddProject />
                  <Navbar />
                  <ProjectsDashboard />
                </RequireAuth>
              </>
            }
          />
          <Route
            exact
            path="/messages"
            element={
              <>
                <Navbar />
                <RequireAuth>
                  <ContactDashboard />
                </RequireAuth>
              </>
            }
          />
        </Routes>
      </Router>
    );
  }
}
